import CustomPopover from "./popover";


export const KvkNummerPopOver = () => {
    return (
        <CustomPopover position="top-[34px] right-[5px]">
        <div>
        <p className="mb-2 text-sm font-semibold text-ink">
          Kvk Nummer:
          </p>
          <ul className="list-disc pl-5 text-sm text-ink-subtle">
            <li>Vul hier het KvK-nummer van de klant in.</li>
            <li>Het KvK-nummer bestaat uit 8 cijfers.</li>
          </ul>
          <p className="mt-2 text-xs text-ink-subtlest">
          <i>Controleer of het nummer correct is ingevoerd.</i>
          </p>
        </div>
      </CustomPopover>
    );
}

export const HandelsNaamPopOver = () => {
    return (
        <CustomPopover position="top-[34px] right-[5px]">
        <div>
        <p className="mb-2 text-sm font-semibold text-ink">
          Handelsnaam:
          </p>
          <ul className="list-disc pl-5 text-sm text-ink-subtle">
            <li>Handelsnaam van de klant.</li>
          </ul>
          <p className="mt-2 text-xs text-ink-subtlest">
            <i>Controleer of dit correct is.</i>
          </p>
        </div>
      </CustomPopover>
    );
}

export const VoorLettersPopOver = () => {
    return (
        <CustomPopover position="top-[34px] right-[5px]">
        <div>
        <p className="mb-2 text-sm font-semibold text-ink">
          Voorletters:
          </p>
          <ul className="list-disc pl-5 text-sm text-ink-subtle">
            <li>Initialen van de voornamen.</li>
          </ul>
          <p className="mt-2 text-xs text-ink-subtlest">
          <i>Voorbeeld: H.F.</i>
          </p>
        </div>
      </CustomPopover>
    );
}

export const AchterNaamPopOver = () => {
    return (
        <CustomPopover position="top-[34px] right-[5px]">
        <div>
        <p className="mb-2 text-sm font-semibold text-ink">
          Achternaam:
          </p>
          <ul className="list-disc pl-5 text-sm text-ink-subtle">
            <li>De achternaam van de klant.</li>
          </ul>
          <p className="mt-2 text-xs text-ink-subtlest">
          <i>Controleer of het correct is.</i>
          </p>
        </div>
      </CustomPopover>
    );
}

export const StraatNaamPopOver = () => {
    return (
        <CustomPopover position="top-[34px] right-[5px]">
        <div>
        <p className="mb-2 text-sm font-semibold text-ink">
          Straatnaam:
          </p>
          <ul className="list-disc pl-5 text-sm text-ink-subtle">
            <li>Officiele adres die bekent is van de onderneming.</li>
          </ul>
          <p className="mt-2 text-xs text-ink-subtlest">
          <i>Controleer of het correct is.</i>
          </p>
        </div>
      </CustomPopover>
    );
}

export const HuisNummerPopOver = () => {
    return (
        <CustomPopover position="top-[34px] right-[5px]">
        <div>
        <p className="mb-2 text-sm font-semibold text-ink">
          Huisnummer:
          </p>
          <ul className="list-disc pl-5 text-sm text-ink-subtle">
            <li>Huisnummer van de onderneming.</li>
            <li>Vermeld eventuele toevoegingen bij het huisnummer.</li>
          </ul>
          <p className="mt-2 text-xs text-ink-subtlest">
            <i>Bijvoorbeeld: 17 B</i>
          </p>
        </div>
      </CustomPopover>
    );
}


export const PostCodePopOver = () => {
    return (
        <CustomPopover position="top-[34px] right-[5px]">
        <div>
        <p className="mb-2 text-sm font-semibold text-ink">
          Postcode:
          </p>
          <ul className="list-disc pl-5 text-sm text-ink-subtle">
            <li>Postcode van de onderneming.</li>
          </ul>
          <p className="mt-2 text-xs text-ink-subtlest">
            <i>Controleer of het correct is.</i>
          </p>
        </div>
      </CustomPopover>
    );
}


export const PlaatsPopOver = () => {
    return (
        <CustomPopover position="top-[34px] right-[5px]">
        <div>
        <p className="mb-2 text-sm font-semibold text-ink">
          Plaats:
          </p>
          <ul className="list-disc pl-5 text-sm text-ink-subtle">
            <li>Plaats van de onderneming</li>
          </ul>
          <p className="mt-2 text-xs text-ink-subtlest">
            <i>Bijvoorbeeld: Amsterdam</i>
          </p>
        </div>
      </CustomPopover>
    );
}


export const TelefoonNummerPopOver = () => {
    return (
        <CustomPopover position="top-[34px] right-[5px]">
        <div>
        <p className="mb-2 text-sm font-semibold text-ink">
          Telefoonnummer:
          </p>
          <ul className="list-disc pl-5 text-sm text-ink-subtle">
            <li>Telefoonnummer van de klant.</li>
          </ul>
          <p className="mt-2 text-xs text-ink-subtlest">
            <i>Controleer of het correct is.</i>
          </p>
        </div>
      </CustomPopover>
    );
}


export const EmailPopOver = () => {
    return (
        <CustomPopover position="top-[34px] right-[5px]">
        <div>
        <p className="mb-2 text-sm font-semibold text-ink">
          Email:
          </p>
          <ul className="list-disc pl-5 text-sm text-ink-subtle">
            <li>Email-adres van de klant.</li>
          </ul>
          <p className="mt-2 text-xs text-ink-subtlest">
            <i>Controleer of het correct is.</i>
          </p>
        </div>
      </CustomPopover>
    );
}


export const MeldCodePopOver = ({position}) => {
    return (
        <CustomPopover position={position}>
        <div>
        <p className="mb-2 text-sm font-semibold text-ink">
          Meldcode:
          </p>
          <ul className="list-disc pl-5 text-sm text-ink-subtle">
            <li>Voer hier de meldcode op die te vinden is op de apparatenlijst ISDE.</li>
          </ul>
          <p className="mt-2 text-xs text-ink-subtlest">
          Voor meer informatie over meldcodes op de apparatenlijst en hoe deze te vinden, bezoek <a  href="https://www.rvo.nl/" target="_blank" rel="noopener noreferrer" className="text-brand hover:underline">rvo.nl</a>.
          </p>
        </div>
      </CustomPopover>
    );
}


export const BedrijfsMiddelCodePopOver = ({position}) => {
  return (
      <CustomPopover position={position}>
      <div>
      <p className="mb-2 text-sm font-semibold text-ink">
      Bedrijfsmiddelcode:
        </p>
        <ul className="list-disc pl-5 text-sm text-ink-subtle">
          <li>Voer hier de Bedrijfsmiddelcode op die te vinden is op de energielijst.</li>
        </ul>
        <p className="mt-2 text-xs text-ink-subtlest">
        <i>Je kunt de energielijst vinden op de website van </i><a href="https://rvo.nl" target="_blank" rel="noopener noreferrer" className="text-brand hover:underline">rvo.nl</a>
        </p>
      </div>
    </CustomPopover>
  );
}

export const DatumOpdrachtBevestigingPopOver = ({position}) => {
    return (
        <CustomPopover position={position}>
        <div>
        <p className="mb-2 text-sm font-semibold text-ink">
          Datum Opdracht Bevestiging:
          </p>
          <ul className="list-disc pl-5 text-sm text-ink-subtle">
            <li>Datum dat de opdracht is bevestigd</li>
          </ul>
          <p className="mt-2 text-xs text-ink-subtlest">
           <i>Controleer of dit correct is.</i>
          </p>
        </div>
      </CustomPopover>
    );
}


export const AantekeningVoorOnsPopOver = ({position}) => {
    return (
        <CustomPopover position={position}>
        <div>
        <p className="mb-2 text-sm font-semibold text-ink">
          Aantekening Voor Ons:
          </p>
          <p className="mt-2 text-xs text-ink-subtlest">
            Mocht u wat extra informatie willen geven, dan kan dat hier.
          </p>
        </div>
      </CustomPopover>
    );
}


export const KenmerkPopOver = () => {
    return (
        <CustomPopover position="top-[34px] right-[5px]">
        <div>
        <p className="mb-2 text-sm font-semibold text-ink">
          Uw Kenmerk:
          </p>
          <p className="mt-2 text-xs text-ink-subtlest">
            Dit is puur voor uw eigen administratie.
          </p>
          <i className="text-xs text-ink-subtlest">Bijvoorbeeld: EIA-4567</i>
        </div>
      </CustomPopover>
    );
}

export const KopieOndertekendeOffertePopOver = ({position}) => {
    return (
        <CustomPopover position={position}>
        <div>
        <p className="mb-2 text-sm font-semibold text-ink">
          Kopie Ondertekende Offerte:
          </p>
          <ul className="list-disc pl-5 text-sm text-ink-subtle">
            <li>Upload een goedzichtbare bestand.</li>
          </ul>
          <p className="mb-2 text-sm font-semibold text-ink">
          * maximale upload size 10mb
          </p>
        </div>
      </CustomPopover>
    );
}


export const AantalZonnepanelenPopOver = () => {
    return (
        <CustomPopover position="top-[34px] right-[5px]">
        <div>
        <p className="mb-2 text-sm font-semibold text-ink">
          Aantal Zonnepanelen:
          </p>
          <ul className="list-disc pl-5 text-sm text-ink-subtle">
            <li>Voer het aantal zonnepanelen hier in.</li>
          </ul>
          <p className="mt-2 text-xs text-ink-subtlest">
            <i>Controleer of dit correct is.</i>
          </p>
        </div>
      </CustomPopover>
    );
}

export const TotaalVermogenPopOver = () => {
    return (
        <CustomPopover position="top-[34px] right-[5px]">
        <div>
        <p className="mb-2 text-sm font-semibold text-ink">
          Totaal Vermogen:
          </p>
          <ul className="list-disc pl-5 text-sm text-ink-subtle">
            <li><strong>Minimaal:</strong> 15.000 WP</li>
            <li><strong>Maximaal:</strong> 55.000 WP</li>
          </ul>
          <p className="mt-2 text-xs text-ink-subtlest">
            <i>Controleer dit zorgvuldig, dit beïnvloed de goedkeuring.</i>
          </p>
        </div>
      </CustomPopover>
    );
}


export const TypePopOver = ({position}) => {
    return (
        <CustomPopover position={position}>
        <div>
        <p className="mb-2 text-sm font-semibold text-ink">
        Bijlage energienota voor Warmtepomp:
          </p>
          <p className="mb-2 text-sm font-medium text-ink">
          Gelieve een kopie van uw energienota bij te voegen.</p>
          <p className="mb-2 text-sm text-ink">Voor lucht-water-warmtepompen geldt:</p>
          <ul className="list-disc pl-5 text-sm text-ink-subtle">
          <li>Uw locatie heeft een jaarlijks energieverbruik lager dan 50.000 kWh stroom en 25.000 m³ aardgas.</li>
          <li>Bij overschrijding van deze verbruiksgrenzen in het voorafgaande jaar komt u vanaf 1 juli 2023 niet in aanmerking voor subsidie voor een lucht-water-warmtepomp.</li>
          <li>Indien uw locatie van het gasnet wordt (of al is) afgesloten, is een subsidie wel mogelijk.</li>
          </ul>
          <p className="mt-2 text-xs text-ink-subtlest">
            <i>Let op: deze voorwaarde geldt niet voor water-water-warmtepompen en grondwater-warmtepompen.</i>
          </p>
          <p className="mt-2 text-xs text-ink-subtlest">
            <i>Indien u geen jaarlijkste jaarnota heeft. Dien dan de meest recente maandafrekening.</i>
          </p>
        </div>
      </CustomPopover>
    );
}